import { AnimatePresence, motion } from "motion/react";
import useAppStore from "../store/useAppStore";
import useLayoutStore from "../store/useLayoutStore";

import PresenceView from "./views/PresenceView";
import StatsView from "./views/StatsView";
import KarnetFormView from "./views/KarnetFormView";
import DevicesView from "./views/DevicesView";
import SettingsView from "./views/SettingsView";
import CalendarView from "./views/CalendarView";

const InterfaceContentSwitcher = () => {
    const activeSection = useAppStore(state => state.activeSection);
    const isDarkTheme = useLayoutStore(state => state.isDarkTheme)

    const getActiveView = () => {
        switch (activeSection) {
            case "Prisutnost":
                return <PresenceView />;
            case "Statistika":
                return <StatsView />;
            case "Karnet-obrazac":
                return <KarnetFormView />;
            case "Status uređaja":
                return <DevicesView />;
            case "Podešavanja":
                return <SettingsView />;
            case "Kalendar":
                return <CalendarView />;
            default:
                return null;
        }
    };

    return (
        // <div className="interface-content white-theme-1">
        <div className={`interface-content ${isDarkTheme ? 'dark-theme-1' : 'white-theme-1'}`} >
            <AnimatePresence mode="wait">
                <motion.div
                    key={activeSection}
                    initial={{ opacity: 0.8, x: 100 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -400, transition: { duration: 0.19 } }}
                    style={{ height: "100%" }}
                >
                    {getActiveView()}
                </motion.div>
            </AnimatePresence>
        </div>
    );
}

export default InterfaceContentSwitcher;
